var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","font-size":"0.24rem"}},[_c('ul',{staticClass:"enable-list-type"},[_c('li',[_vm._v("\n      首次存款需达到最低存款金额，否则无法激活账户进行交易，当前账户最低存款金额是$"+_vm._s(_vm.minDepositAmt)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }